import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/editor.scss";
import "../css/LeftPanel.scss";
import "../css/TemplateManger.scss";
import "../css/EditorWrapper.scss";
// import "../css/common.scss";
import ActiveFlowCreatorIcon from "../images/Active-Flow-Creator-Icon.svg";
import FlowCreatorInfoIcon from "../images/InfoIconblue.svg";
import gridIcon from "../images/gridIcon.svg";
import HTMLFile from "../images/HTML-File.svg";
import HTMLDisableFile from "../images/HTMLFile.svg";
import CheckmarkIcon from "../images/checkmark-icon.svg";
import EditIconInActive from "../images/EditIcon.svg";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Button from "react-bootstrap/Button";
import { MediaTabFunction } from "../utils/editorUtils/editorUtils";
import MenuItem from "@mui/material/MenuItem";
import ListOfSlides from "./ListOfSildes";
import { geteDetailByID, postZipPackage } from "../services/apis";
import CustomModal from "../components/CustomModal";
import ImportIcon from "../images/Import-Icon.svg";
import uploadSuccess from "../images/upload-import-success.svg";
import warningUpload from "../images/warning-upload-pkg.svg";
import CloseIcon from "../images/Close-Small.svg";
import SuccessIcon from "../images/Success-Icon.svg";
import ErrorIcon from "../images/Error-Icon.svg";

import "../css/listOfSlides.scss";
import PresentationStatus from "./PresentationStatus/PresentationStatus";
import {
  showErrorToast,
  showSuccessToast,
} from "./toastComponent/ToastComponent";

const SlideSwapperLeftPanel = ({
  editor,
  setState,
  showAllSlides,
  showSlidesPanel,
  appData,
  getVeevaLinkedmodules,
  setDeckData,
  setSlideID,
  setCurrentSlide,
  swapped,
  setSlideCount,
  setSwapped,
  slideID,
  setSaveLoading,
  setShowAllSlides,
  setLoadSuccess,
  setFlowCreatorLoading,
  isPdfFlow = false,
}) => {
  MediaTabFunction(setState);

  const navigate = useNavigate();
  const [slidesData, setSlidesData] = useState();
  const [openPopup, setOpenPopup] = useState(false);
  const [currentSlideId, setCurrentSlideId] = useState([]);
  const [slideIndex, setSlideIndex] = useState(null);

  useEffect(() => {
    setFlowCreatorLoading(false);
  }, []);

  let slides = [];
  const getAppData = async (id) => {
    await geteDetailByID(
      appData?.deckId?._id,
      async (response, err, errorCode) => {
        if (err) {
        } else {
          let data = await response.data;
          appData.setDeckId(data);
          setDeckData(data);
          setNameDrop(response.data);
          slides = data?.slides;
          const slidesList = [];
          data?.slides?.forEach((element) => {
            slidesList.push({ id: element.slideid, name: element.slideid });
          });
          window.localStorage.setItem("slidelist", JSON.stringify(slidesList));
          // end
        }
      }
    );
  };
  const toggleSlidesPanelNEditor = async () => {
    window.localStorage.removeItem("gjsProject");
    // await getSlidesListForDeck();
    // ids = slides;
    await getAppData();
    if (slides === undefined) return;
    // if (appData?.deckId?._id !== undefined) {
    //   getVeevaLinkedmodules(slides[0]?.slideid?._id);
    // }
    setSlideID(slides);
    setCurrentSlide({ master: slides[0], child: {} });
    setSlideCount(1);

    //navigate to first slide
    navigate(`/editor/${slides[0].slideid._id}`, { replace: true });
    // }
    showSlidesPanel(!showAllSlides);
  };

  const selectedCardHandler = (data, currentSlide, slideIndex) => {
    const id = [];
    id.push(currentSlide);
    setCurrentSlideId([...id]);
    /* setSlidesData(id); */
    setSlideIndex(slideIndex);
    const classExist = document.querySelectorAll(".selected-card");
    if (classExist.length > 0) {
      setSlidesData(id);
    } else {
      setSlidesData();
    }
    window.localStorage.setItem("currentSlideId", id);
  };
  const [insertIndex, setInsertIndex] = useState(null);
  const handleSlideIndex = (e) => {
    if (e.target.value === "After") {
      setInsertIndex(slideIndex + 1);
    } else if (e.target.value === "Before") {
      setInsertIndex(slideIndex === 0 ? 0 : slideIndex);
    }
  };
  const [filesData, setFilesData] = useState("");
  const [filename, setFileName] = useState("");
  const [expandDetailDrop, setExpandDetailDrop] = useState(false);
  const [nameDrop, setNameDrop] = useState();

  const handleFileReader = (event, action) => {
    setFilesData(event.target.files[0]);

    // var fileName = document.getElementById("fileUpload").files[0].name;
    // setFileName(fileName);
    if (action === "upload") {
      const fileName = document.getElementById("fileUpload").files[0].name;
      setFileName(fileName);
    } else {
      const fileName =
        document.getElementById("fileUploadRefresh").files[0].name;
      setFileName(fileName);
    }
  };

  const handleFileImport = () => {
    const formData = new FormData();
    formData.append("file", filesData);
    formData.append("slideIndex", insertIndex);

    postZipPackage(
      appData?.deckId?._id,
      formData,
      (response, err, errorCode) => {
        if (err) {
          showErrorToast(
            err?.response?.data?.error || err?.response?.data?.message
          );
        } else {
          let data = response.data;
          showSuccessToast("Slide import initiated. Link will be mailed");
        }
      }
    );
    setFileName("");
    setInsertIndex(null);
    setOpenPopup(false);
  };

  const expandName = () => {
    setExpandDetailDrop(!expandDetailDrop);
  };

  return (
    <div className="swapperPage ">
      {/* <div className={"leftPanelSlidesSwapper "}>
        <ul className=" mb-0 listItemSideBar pl-0 ulClass">
          <div className={"topIcons"}>
            <li
              onClick={toggleSlidesPanelNEditor}
              className={"inactiveSidebar1"}
            >
              <img
                alt="slide"
                src={EditIconInActive}
                id="edit-img"
                className={showAllSlides && "active-silde-icon1"}
              ></img>
            </li>
            <li onClick={toggleSlidesPanelNEditor} className={"activeSidebar1"}>
              <img
                alt="slide"
                src={ActiveFlowCreatorIcon}
                id="edit-img"
                className={"slideIcon"}
              ></img>
            </li>
          </div>
          <li className={"bottomGridIcon"}>
            <img
              id="grid"
              alt="grid"
              src={gridIcon}
              onClick={() => {
                //    appData.setToggleTemplate(1);
                setTimeout(() => {
                  editor?.destroy();
                }, 0);
                navigate("/", {
                  replace: true,
                  state: {
                    type: localStorage.getItem("categoryType") === "2" ? 2 : 1,
                  },
                });
              }}
            />
          </li>
        </ul>
      </div> */}
      <div className="SwappingArea ">
        <div className="d-flex All-slides">
          <div className="left-side">
            <PresentationStatus
              expandDetailDrop={expandDetailDrop}
              setExpandDetailDrop={setExpandDetailDrop}
              nameDrop={appData?.deckId}
              expandName={expandName}
              editor={editor}
              navigate={navigate}
              flowCreator={true}
              toggleSlidesPanelNEditor={toggleSlidesPanelNEditor}
              slidesData={slidesData}
              setOpenPopup={setOpenPopup}
              setShowAllSlides={setShowAllSlides}
              setLoadSuccess={setLoadSuccess}
              isPdfFlow={isPdfFlow}
            />
          </div>
          <div className="right-side"></div>
        </div>
        <ListOfSlides
          data={appData?.deckId}
          setSwapped={setSwapped}
          slideID={slideID}
          setSlideID={setSlideID}
          setSaveLoading={setSaveLoading}
          selectedCardHandler={isPdfFlow ? () => {} : selectedCardHandler}
          slidesData={slidesData}
          currentSlideId={currentSlideId}
          slideIndex={slideIndex}
          isPdfFlow={isPdfFlow}
        />
        {/* <div className="d-flex flow-creator-footer justify-content-end align-items-center">
          <div className="flow-creator-text">
            <img
              className="flow-creator-icon"
              src={FlowCreatorInfoIcon}
              width={12}
              height={12}
            />
            <span>Select a file to Import</span>
          </div>
          <button
            className={`btn btn-default ${
              slidesData
                ? "flow-creator-enabled-button"
                : "flow-creator-desabled-button"
            }`}
            disabled={slidesData ? false : true}
            onClick={() => setOpenPopup(true)}
          >
            IMPORT HTML ZIP PACKAGE
          </button>
        </div> */}
      </div>{" "}
      {!isPdfFlow && openPopup && (
        <CustomModal
          displayModal={openPopup}
          hideModal={() => {}}
          title={""}
          size="sm"
          dilogClassName="import-pkg-modal"
          keyboard={false}
        >
          <div className="importContentWrapper">
            <div className="importHeader">
              <img className="" src={ImportIcon} width={12} height={16} />
              Import HTML zip package
            </div>
            <div
              className={`import-html ${
                filename ? "file-uploaded" : "file-not-upload"
              }`}
            >
              {/* <div className="d-flex"> */}
              <label className="import-html-label">
                {filename === "" ? (
                  <img src={HTMLFile} width={20} height={20} alt="image" />
                ) : (
                  <img
                    src={HTMLDisableFile}
                    width={14.4}
                    height={18}
                    alt="image"
                  />
                )}
                {filename === "" ? (
                  <span>Select to browse & choose file</span>
                ) : (
                  ""
                )}
                <input
                  type="file"
                  id={"fileUpload"}
                  accept=".zip"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileReader(e, "upload")}
                />
              </label>
              {/* </div> */}
              {filename !== "" ? (
                <div className="importStatus">
                  {/* <span>{filename !== "" ? filename : ""}</span> */}
                  <span>
                    <img
                      src={CheckmarkIcon}
                      width={12}
                      height={12}
                      alt="image"
                    />
                    <span className="file-uploaded-text">{filename}</span>
                  </span>
                  {/* <span className="replace-text">Replace</span> */}
                  <label>
                    <input
                      type="file"
                      id={"fileUploadRefresh"}
                      accept=".zip"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileReader(e, "refresh")}
                    />
                    <span className="replace-text">Replace</span>
                  </label>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="slide-order-selection">
              <FormControl fullWidth className="FormControl" size="small">
                <InputLabel
                  //  id="demo-simple-select-label"
                  style={{
                    fontSize: "12px",
                    transformOrigin: "top",
                    color: "#66676b",
                    position: "absolute",
                    //left: "-12px"
                  }}
                >
                  Slide location
                </InputLabel>
                <Select
                  labelId="select-slide-import"
                  id="demo-select-small"
                  className="MUI-selectbox-customChng"
                  //value={searchMetadata?.device?.name || ""}
                  label="Slide location"
                  onChange={(e) => handleSlideIndex(e)}
                  name="Slidelocation"
                  style={{
                    fontSize: "12px",
                    color: "#231f20",
                    fontWeight: "600",
                    padding: "5px 0 0 0",
                    letterSpacing: "0.12px",
                  }}
                >
                  {/* {appData.devices.map((device) => (
                      <MenuItem value={device.name}>{device.name}</MenuItem>
                    ))} */}
                  <MenuItem value="After" className="orderSelection-menu">
                    After
                  </MenuItem>
                  <MenuItem value="Before" className="orderSelection-menu">
                    Before
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="importFooter">
            <div className="importFooterSeparator"></div>
            <Button
              className="btn close-import"
              type="button"
              onClick={() => {
                setFileName("");
                setInsertIndex(null);
                setOpenPopup(false);
              }}
            >
              CLOSE
            </Button>
            <Button
              className="btn import-pkg"
              type="button"
              onClick={() => handleFileImport()}
              disabled={!(filename && insertIndex)}
            >
              IMPORT
            </Button>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default SlideSwapperLeftPanel;
